module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/photo_exhibition-77a7cb889447b17d418c14acd9d7eecf.jpg";